export default __webpack_public_path__ + "static/media/oscer-pres-weight-gain.e42e96f6.svg";